export default __webpack_public_path__ + "static/media/1(19).c0244b3b.jpg";